import { render, staticRenderFns } from "./MandalaGoalTemplateFormActivityGoalItem.vue?vue&type=template&id=7187a971&scoped=true&"
import script from "./MandalaGoalTemplateFormActivityGoalItem.vue?vue&type=script&lang=js&"
export * from "./MandalaGoalTemplateFormActivityGoalItem.vue?vue&type=script&lang=js&"
import style0 from "./MandalaGoalTemplateFormActivityGoalItem.vue?vue&type=style&index=0&id=7187a971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187a971",
  null
  
)

export default component.exports